import { AuthModal } from '@zoopla/authentication/modal';
import { RefObject } from 'react';
import { SaveThisSearchModal } from './SaveThisSearchModal';
import { UseSaveThisSearchModal } from './useSaveThisSearchModal';
import { AnalyticsTaxonomy } from '@zoopla/listing-search-context';

type SaveThisSearchModalWithAuthProps = UseSaveThisSearchModal & {
    container?: RefObject<HTMLDivElement>;
    analyticsTaxonomy?: AnalyticsTaxonomy;
};

export const SaveThisSearchModalWithAuth = ({
    showAuthModal,
    setShowAuthModal,
    defaultAlertFrequency,
    showSaveThisSearchModal,
    setShowSaveThisSearchModal,
    container,
    analyticsTaxonomy
}: SaveThisSearchModalWithAuthProps) => {
    return (
        <>
            <AuthModal
                trackingData={{
                    label:
                        defaultAlertFrequency === ''
                            ? 'save_search'
                            : 'create_alert',
                    segmentData: {
                        page: analyticsTaxonomy?.page || '/for-sale/results/',
                        section: analyticsTaxonomy?.section || 'for-sale'
                    }
                }}
                close={(hasAuthenticated) => {
                    setShowAuthModal(false);

                    if (hasAuthenticated) {
                        setShowSaveThisSearchModal(true);
                    }
                }}
                initialMode="sign-in"
                isShowing={showAuthModal}
            />

            <SaveThisSearchModal
                defaultAlertFrequency={defaultAlertFrequency}
                isOpen={showSaveThisSearchModal}
                onOpenChange={setShowSaveThisSearchModal}
                container={container}
            />
        </>
    );
};
